import React from "react";

const Confident = () => {
  const doctors = [
    {
      name: "Dr. Aaradhya Sharma",
      specialty: "Gynaecologist & Your Pregnancy Friend",
      degree: "MBBS, DGO, MD (Obs & Gyn)",
      experience: "11 Years of Experience",
    },
    {
      name: "Dr. Chayya Palan",
      specialty: "Emotional Health Expert & Partner in Mind-Body Wellness",
      degree:
        "MSc (Clinical Psychology), Advance Diploma in Counselling Psychology",
      experience: "11 Years of Experience",
    },
    {
      name: "Dr. Anuradha Tikhe",
      specialty: "Dietitian, Your Steady Hand & Reassuring Voice",
      degree: "BHMS, MPH (Mumbai), Certified Pregnancy Nutritionist",
      experience: "16+ Years of Experience",
    },
    {
      name: "Dr. Gayatri Navale",
      specialty: "Gynaecologist & Your Safe Space",
      degree: "MBBS, DGO, MD (Obs & Gyn)",
      experience: "13 Years of Experience",
    },
  ];

  return (
    <div className="experts-section-wrapper">
      <img src="/CraftersR.png" className="floral-corner left" alt="" />
      <img src="/CraftersL.png" className="floral-corner right" alt="" />

      <div className="container py-5 text-center">
        <div className="experts-header mb-5">
          <h2 className="journey-title">
            Meet the Crafters of <span className="pink-text">Your Journey</span>
          </h2>
          <p className="journey-subtitle mx-auto">
            You don't just need a prescription; you need a partnership. Unlike traditional clinics where you are just another file, our experts are your dedicated advocates. Handpicked for their clinical brilliance and deep empathy, they look beyond the charts to make sure you feel heard, safe, and beautifully supported every single day.
          </p>
        </div>

        <div className="row justify-content-center g-4 mb-5">
          {doctors.map((doctor, index) => (
            <div key={doctor.name} className="col-lg-3 col-md-6">
              <div className="doctor-stamp-card">
                <div className="stamp-img-wrapper">
                  <img src="/unvdr.png" alt="Doctor" />
                </div>
                <div className="doctor-info mt-3">
                  <h4 className="doc-name">{doctor.name}</h4>
                  <p className="doc-specialty">{doctor.specialty}</p>
                  <p className="doc-degree">{doctor.degree}</p>
                  <p className="doc-experience">{doctor.experience}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-4">
          <a href="/Doctor-profile" className="btn-get-to-know">
            Get to Know Your Complete Circle of Care
          </a>
        </div>
      </div>
    </div>
  );
};

export default Confident;
